<template>
  <v-chip
    :color="color"
    variant="outlined"
    size="small"
    class="font-weight-medium so-badge"
  >
    <slot></slot>
  </v-chip>
</template>

<script lang="ts">
  import { defineComponent } from "vue"

  export default defineComponent({
    props: {
      color: {
        type: String,
        default: "default",
        required: false,
      },
    },
  })
</script>
<style scoped>
  .so-badge {
    border-radius: 4px !important;
    border-width: 2px !important;
    min-width: fit-content;
  }
  :deep(.v-chip__content) {
    font-size: 0.875rem !important;
  }
</style>
